export default "__VITE_ASSET__a0f208c4__"